import { toast as sonnerToast } from "sonner"

type ToastType = {
  title: string
  description?: string
}

export function useToast() {
  const toast = ({ title, description }: ToastType) => {
    sonnerToast(title, {
      description,
    })
  }

  return { toast }
}
